import Metrics from '@/components/Metrics/Metrics';
import config from '@/config';
import { useAuth } from '@/providers/AuthProvider';
import { useParams } from 'react-router-dom';

function Insights() {
  const { user, groups, tenant } = useAuth();
  const { tenantId } = useParams();

  const isAdmin = groups.find((group) => group.includes('admin')) !== undefined;
  const isPeaceLoveAdmin = groups.includes(config.admin.superAdminGroup);

  const actualTenantId = tenantId ?? (tenant as string);

  if (!actualTenantId) {
    return null;
  }

  return (
    <Metrics
      tenantId={
        isPeaceLoveAdmin && !tenantId ? config.metrics.adminTenantId : (actualTenantId as string)
      }
      hostId={!(isPeaceLoveAdmin || isAdmin) ? user?.userId : undefined}
    />
  );
}

export default Insights;
